"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { InitMuiLicense } from "@climatepartner/components";
import { AuthenticationProvider } from "../../providers/AuthenticationContext";
import { DashboardLayout } from "./DashboardLayout";
InitMuiLicense();
export function AppShell(props) {
    return (_jsx(AuthenticationProvider, { oidcConfig: props.oidcConfig, children: _jsx(DashboardLayout, { ...props, children: props.children }) }));
}
export default AppShell;
//# sourceMappingURL=AppShell.js.map